export default (initialState = []) => {
  return () => {
    return [...initialState];
  };
};
